import PropTypes from 'prop-types'
import easydropdown from 'easydropdown'
import { useEffect, useRef } from 'react'

function SelectFilter({ name, value, options, placeholder, handleFilter }) {
  const ref = useRef()
  const eddRef = useRef()

  useEffect(() => {
    if (ref.current) {
      const edd = easydropdown(ref.current, {
        behavior: {
          liveUpdates: true,
        },
      })

      eddRef.current = edd

      ref.current.addEventListener('change', (e) => {
        handleFilter(e.target.name, e.target.value)
      })
    }

    return () => {
      eddRef.current.destroy()
    }
  }, [ref])

  return (
    <select name={name} ref={ref} value={value} onChange={() => {}}>
      <option value="" data-placeholder>
        {placeholder}
      </option>

      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  )
}

SelectFilter.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  handleFilter: PropTypes.func,
}

export default SelectFilter
